import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss']
})
export class TextInputComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() name: string;
  @Input() type = 'text';
  @Input() description = '';
  private _disabled = false;

  @Input()
  set disabled(value: boolean | string) {
    this._disabled = value === '' || value === true || value === 'true';
    this.applyDisabledState();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  constructor(
    @Self() public ngControl: NgControl
  ) {
    this.ngControl.valueAccessor = this
  }

  writeValue(obj: any): void {
    // throw new Error('Method not implemented.');
  }
  registerOnChange(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  private applyDisabledState(): void {
    const control = this.ngControl?.control;
    if (!control) return;

    if (this._disabled && control.enabled) {
      control.disable({ emitEvent: false });
    } else if (!this._disabled && control.disabled) {
      control.enable({ emitEvent: false });
    }
  }

}
